import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseUrl } from "./Base/baseApiModel"

export const userAdministrationApi = createApi({
  reducerPath: 'userAdministrationApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().authStore?.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Users', 'Roles'],
  endpoints: (builder) => ({
    // Kullanıcıları listele
    getUsers: builder.query({
      query: (params) => ({
        url: '/UserAdministration/users',
        method: 'POST',
        body: params || {
          page: 0,
          pageSize: 10,
          searchTerm: "",
          roleFilter: "",
          emailConfirmedFilter: null,
          sortBy: "email",
          sortDirection: "asc"
        },
      }),
      providesTags: ['Users'],
    }),

    // Rolleri getir
    getRoles: builder.query({
      query: () => ({
        url: '/UserRole/GetRoles',
        method: 'GET',
      }),
      providesTags: ['Roles'],
    }),

    // Tüm kullanıcıları getir (rol atama için)
    getAllUsers: builder.query({
      query: () => ({
        url: '/UserRole/GetUsers',
        method: 'GET',
      }),
      providesTags: ['Users'],
    }),

    // Kullanıcıya rol ata
    addUserRole: builder.mutation({
      query: (data) => ({
        url: data.remove 
          ? '/UserRole/RemoveUserRole' 
          : '/UserRole/AddUserRole',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Users'],
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetRolesQuery,
  useGetAllUsersQuery,
  useAddUserRoleMutation,
} = userAdministrationApi;
